import { z } from 'zod';
import { extendZodWithOpenApi } from '@hono/zod-openapi';
import 'zod-openapi/extend';
extendZodWithOpenApi(z);
import { GmodPositionSchema } from './PositionSchema.js';
import { GmodAngleSchema } from './AngleSchema.js';

export const GmodEntitySchema = z
	.object({
		class: z.string().openapi({
			example: 'prop_physics',
			description: 'Class of the entity',
		}),
		model: z.string().openapi({
			example: 'models/props_c17/oildrum001.mdl',
			description: 'Model of the entity',
		}),
		position: GmodPositionSchema,
		angle: GmodAngleSchema,
	})
	.openapi({ ref: 'Gmod Entity' });

export type GmodEntityInput = z.infer<typeof GmodEntitySchema>;
